"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PREFFERED_COUNTRIES = exports.DEFAULT_COUNTRY = void 0;
exports.DEFAULT_COUNTRY = 'us';
exports.PREFFERED_COUNTRIES = ['us', 'ca', 'mx'];
